<template>
  <Layout>
    <PageHeader :title="title" :items="itemsPageHeader" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Application</h4>
            <div v-if="action !== 'new'" class="form-group row mb-4">
              <label class="col-form-label col-lg-2">ID</label>
              <label class="col-form-label col-lg-8">{{
                createModel.id
              }}</label>
            </div>
            <validationObserver ref="addApplicationForm" tag="form">
              <form @submit.prevent="onSubmit">
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Name</label>
                  <div class="col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      ref="displayname"
                      name="Display Name"
                      :rules="{
                        required: true,
                        duplicateName: [isDuplicateName, 'Already exist'],
                      }"
                    >
                      <input
                        id="displayname"
                        name="displayname"
                        v-model="createModel.display_name"
                        type="text"
                        class="form-control"
                        placeholder="Name"
                        maxlength="30"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid':
                            !(errors && errors.length) &&
                            createModel.display_name,
                        }"
                        v-on:keyup="onValidateDisplayname($event)"
                      />
                      <div
                        v-if="errors && errors.length"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Code</label>
                  <div class="col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      ref="code"
                      name="Code"
                      :rules="{
                        required: true,
                        duplicateName: [isDuplicateCode, 'Already exist'],
                      }"
                    >
                      <input
                        id="code"
                        name="code"
                        v-model="createModel.code"
                        type="text"
                        class="form-control"
                        placeholder="Code"
                        maxlength="30"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid':
                            !(errors && errors.length) &&
                            createModel.display_name,
                        }"
                        v-on:keyup="onValidateCode($event)"
                      />
                      <div
                        v-if="errors && errors.length"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Status</label>
                  <div class="col-form-label col-lg-8">
                    <div class="row col-lg-12">
                      <b-form-radio
                        v-model="createModel.status"
                        name="status"
                        class="custom-control custom-radio custom-radio-info mb-3"
                        value="Active"
                        style="margin-right: 10px"
                        >Active</b-form-radio
                      >
                      <b-form-radio
                        v-model="createModel.status"
                        name="status"
                        class="custom-control custom-radio custom-radio-info mb-3"
                        value="Inactive"
                        style="margin-right: 10px"
                        >Inactive</b-form-radio
                      >
                    </div>
                  </div>
                </div>
                <!-- <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2"
                    >Logo application</label
                  >
                  <div class="col-lg-8">
                    <vue-dropzone
                      id="dropzone"
                      ref="myVueDropzone"
                      :use-custom-slot="true"
                      :options="dropzoneOptions"
                    >
                      <div class="dropzone-custom-content">
                        <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </vue-dropzone>
                  </div>
                </div> -->
                <div class="form-group mb-4 text-center">
                  <div class="button-items">
                    <button type="submit" class="btn btn-primary">Save</button>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click="onCancel()"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </validationObserver>
          </div>
        </div>
      </div>
    </div>
    <loading :active.sync="isLoading" ></loading>

    <!-- end row -->
    <!-- detail -->
    <div class="card" v-if="showDataTable">
      <div class="card-body">
        <div class="row">
          <div class="col-md-8"></div>
          <div class="col-md-4 mb-4">
            <div class="text-sm-right">
              <button
                @click="
                  $router.push({
                    name: 'service_detail',
                    params: { serviceId: 'new' },
                  })
                "
                type="button"
                class="btn btn-success waves-effect waves-light"
              >
                <i class="fa fa-plus"></i>
                Add service
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                Size&nbsp;
                <b-form-select
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                  @change="onFilterService()"
                ></b-form-select
                >&nbsp;Records
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div
              id="tickets-table_filter"
              class="dataTables_filter text-md-right"
            >
              <label class="d-inline-flex align-items-center">
                <b-form-input
                  v-model="search"
                  type="search"
                  :placeholder="`Search in page ${pageNo} `"
                  class="form-control form-control-sm ml-2"
                ></b-form-input>
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive">
              <b-table
                class="table table-centered table-nowrap"
                ref="grouptable"
                :empty-text="'Not found any result'"
                :show-empty="!isItems"
                :bordered="true"
                :filter="search"
                :filter-included-fields="['service_name', 'service_domain']"
                :items="items"
                align="center"
                v-bind:fields="fields"
                @filtered="onFilteredService"
                :perPage="perPage"
              >
                <template v-slot:cell(index)="data">
                  <div class="text-right">
                    {{ firstRowOnPage + data.index }}
                  </div>
                </template>
                <template v-slot:cell(status)="data">
                  <span
                    class="label"
                    :class="'label-' + data.value.toLowerCase()"
                    v-html="data.value"
                  ></span>
                </template>
                <template v-slot:cell(action)="data">
                  <div class="button-items">
                    <button
                      @click="
                        $router.push({
                          name: 'service_detail',
                          params: { id, serviceId: data.item.id },
                        })
                      "
                      type="button"
                      class="btn btn-warning waves-effect waves-light"
                      title="Edit"
                    >
                      <i class="mdi mdi-pencil label-icon"></i>
                    </button>

                    <button
                      @click="onConfirmDelete(createModel.id, data.item.id)"
                      type="button"
                      class="btn btn-danger waves-effect waves-light"
                      title="Delete"
                    >
                      <i class="mdi mdi-trash-can label-icon"></i>
                    </button>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <div class="row" v-if="isItems">
          <div class="col-lg-4">
            <div style="position: relative; top: 7px">
              Result {{ firstRowOnPage }} - {{ lastRowOnPage }} From
              {{ totalRecords }} Records
            </div>
          </div>
          <div class="col-lg-8">
            <b-pagination
              :total-rows="totalRecords"
              :per-page="perPage"
              v-model="pageNo"
              @change="onClickPagination($event)"
              class="pagination pagination-rounded justify-content-end mb-2"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
// import vue2Dropzone from "vue2-dropzone";
// import DatePicker from "vue2-datepicker";
// import Swal from "sweetalert2";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import { required, minLength, maxLength } from "vuelidate/lib/validators";
import applicationService from "@/helpers/service/application-provider";
import serviceService from "@/helpers/service/service-provider";
import { eventBus } from "@/main.js";
import { StatusEnum } from "@/enum/application.enum.js";
import { serviceComputed, serviceMethods } from "@/state/helpers";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
/**
 * Projects-create component
 */
export default {
  page: {
    title: "Create New Application",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader }, //, vueDropzone: vue2Dropzone
  data() {
    return {
      isLoading: false,

      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true,
      },
      id: "",
      action: "new",
      title: "Create New",
      itemsPageHeader: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Application",
          href: "/applications",
        },
        {
          text: "Create New",
          active: true,
        },
      ],
      createModel: {
        id: 0,
        code: "",
        code_old: "",
        display_name: "",
        display_name_old: "",
        status: StatusEnum.ACTIVE,
        channel_allows: [],
        photo: "",
      },
      channelAllows: {
        OAuth: {
          Facebook: false,
          Google: false,
        },
        Basic: {
          AD: true,
          Phone: false,
          Email: false,
        },
      },
      isDuplicateName: false,
      isDuplicateCode: false,
      /* service list */
      showDataTable: false,
      fields: [
        {
          key: "index",
          label: "index",
          thStyle: "width:80px",
          sortable: false,
        },
        {
          key: "service_name",
          label: "Service name",
          sortable: true,
        },
        {
          key: "service_domain",
          label: "Service domain",
          sortable: true,
        },
        {
          key: "service_type",
          label: "Service type",
          sortable: true,
        },
        {
          key: "project_type",
          label: "Project type",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:80px",
        },
      ],
      listModel: {
        type: Object,
        default: () => {
          return {
            firstRowOnPage: 0,
            items: [],
            lastRowOnPage: 0,
            pageNo: 0,
            totalPages: 0,
            totalRecords: 0,
            pageSize: 0,
            prevPage: 0,
            nextPage: 0,
          };
        },
      },
      items: [],
      pageNo: 0,
      totalPages: 0,
      firstRowOnPage: 0,
      lastRowOnPage: 0,
      totalRecords: 0,
      perPage: 50,
      filter: {
        name: "",
      },
      pageOptions: [5, 10, 25, 50, 100],
      search: null,
    };
  },
  created: function () {
    this.id = this.$route.params.id;
    if (this.id === "new") {
      this.action = "new";
      this.title = "Create";
    } else {
      this.action = "edit";
      this.title = "Edit";
    }
  },
  computed: {
    ...serviceComputed,
    isItems() {
      return this.$validate.anyArrayObjectValid(this.items);
    },
  },
  mounted: function () {
    if (this.action === "edit") {
      this.filter = Object.assign({}, this.GET_FILTER_SERVICE);
      // console.log("mounted", this.GET_FILTER_SERVICE);
      this.getDetail();
    }
  },
  watch: {
    GET_FILTER_SERVICE(val, oldVal) {
      //console.log("service", val, oldVal);
      this.filter = Object.assign({}, val);
    },
    listModel: function (value) {
      this.totalPages = value.totalPages;
      this.firstRowOnPage = (value.pageNo - 1) * value.pageSize + 1;
      this.lastRowOnPage =
        value.pageSize <= 0
          ? value.totalRecords
          : Math.min(value.pageNo * value.pageSize, value.totalRecords);
      this.totalRecords = value.totalRecords;
      this.$refs.grouptable.localSortBy = "";
      this.items = value.items;
      this.perPage = value.pageSize;
      this.pageNo = value.pageNo;
    },
  },
  methods: {
    ...serviceMethods,
    async getDetail() {
      //console.log(this.id);
      let result = await applicationService.getApplicationAsync(this.id);
      if (result.status === 200) {
        this.createModel = result.data;
        this.createModel.display_name_old = result.data.display_name;
        await this.onFilterService();
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    async onSubmit() {
      this.isLoading = true
      this.$refs.addApplicationForm.validate().then(async (result) => {
        if (result) {
          if (this.action === "new") {
            let result = await applicationService.createApplicationAsync(
              this.createModel
            );

            this.isLoading = false


            if (result.status === 201) {

              // eventBus.$emit("info-modal", "เพิ่มข้อมูลสำเร็จ");
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              this.$router.push({
                path: "/applications",
              });
              // this.clearForm();
            } else {
              eventBus.$emit("error-modal", result.response.data.message);
            }
          } else {
            let result = await applicationService.updateApplicationAsync(
              this.id,
              this.createModel
            );

            this.isLoading = false

            if (result.status == 204) {
              // eventBus.$emit("info-modal", "แก้ไขข้อมูลสำเร็จ");
              this.$utils.notification("success", "Created", 1500);
              this.$router.push({
                path: "/applications",
              });
            } else {
              eventBus.$emit("error-modal", result.response.data.message);
            }
          }
        }
      });
    },
    onCancel() {
      this.$router.push({
        path: "/applications",
      });
    },
    async onValidateDisplayname() {
      if (
        !(
          this.createModel.display_name.trim() === "" ||
          this.createModel.display_name.trim() === null ||
          this.createModel.display_name.trim() === undefined
        )
      ) {
        if (
          this.action === "edit" &&
          this.createModel.display_name_old ==
            this.createModel.display_name.trim()
        ) {
          return;
        }
        let params = new URLSearchParams();
        params.append("display_name", this.createModel.display_name.trim());
        // if (this.action !== "new") {
        //   params.append("id", this.id);
        // }
        let result = await applicationService.headApplicationAsync(params);
        if (result.status === 200) {
          this.isDuplicateName = true;
        } else if (result.response.status === 404) {
          this.isDuplicateName = false;
        } else {
          eventBus.$emit("error-modal", result.response.data.message);
        }
      }
    },
    async onValidateCode() {
      if (this.$validate.isTrimValid(this.createModel.code)) {
        if (
          this.action === "edit" &&
          this.createModel.code == this.createModel.code.trim()
        ) {
          return;
        }
        let params = new URLSearchParams();
        params.append("code", this.createModel.code.trim());
        if (this.action !== "new") {
          params.append("id", this.id);
        }
        let result = await applicationService.headApplicationAsync(params);
        if (result.status === 200) {
          this.isDuplicateCode = true;
        } else if (result.response.status === 404) {
          this.isDuplicateCode = false;
        } else {
          eventBus.$emit("error-modal", result.response.data.message);
        }
      }
    },
    clearForm() {
      this.createModel = {
        id: 0,
        id_od: "",
        display_name: "",
        status: StatusEnum.ACTIVE,
        ownApplicationStatus: true,
        create_info: {
          timestamp: "",
          user_id: "",
          user_name: "",
        },
        update_info: {
          timestamp: "",
          user_id: "",
          user_name: "",
        },
      };
      this.validateIdOd = false;
      this.invalidDisplayname = false;
      this.invalidCode = false;
      this.textErrorIdOd = "";
      this.textErrorDisplayname = "";
      this.textErrorCode = "";
    },
    async onFilteredService(filteredItems) {
      this.totalPages = filteredItems.length;
    },
    async onClickPagination(pageNo) {
      await this.onFilterService(pageNo);
    },
    async onFilterService(pageNo = 0) {
      this.showDataTable = true;
      let params = new URLSearchParams();
      params.append("pageSize", this.perPage);
      if (pageNo > 0) params.append("page", pageNo);
      params.append("name", this.filter.name.trim() || "");

      let result = await serviceService.getServicesAsync(this.id, params);
      if (result.status === 200) {
        this.listModel = result.data;
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
      this.ADD_FILTER_SERVICE(this.filter);
    },
    async onConfirmDelete(applicationId, serviceId) {
      await this.$utils
        .confirmAlertDisplay(
          `ข้อมูลนี้สำคัญมาก ต้องการลบรายการออกจากชุดข้อมูลนี้ใช่หรือไม่`,
          ""
        )
        .then(async (resultConfirm) => {
          if (resultConfirm) {
            let result = await serviceService.deleteServiceAsync(
              applicationId,
              serviceId
            );

            //console.log(result);
            if (result.status == 200) {
              // eventBus.$emit("info-modal", "แก้ไขข้อมูลสำเร็จ");
              // eventBus.$emit("info-modal", "ลบข้อมูลสำเร็จ");
              this.$utils.notification("success", "ลบข้อมูลสำเร็จ", 1500);
              // this.$utils.notification( 'success', 'Success', 1500);
              window.location.reload();
            } else {
              eventBus.$emit("error-modal", result.response.data.message);
            }
          }
        });
    },
  },
};
</script>

<style scoped>
.switches-channel {
  margin-top: 13px;
}

.dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}

.subtitle {
  color: #314b5f;
}
</style>
